import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Bulk delete drivers by their ID.
 *
 * @private
 */
export const deleteDrivers = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/driver/delete', async (driverIds, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/driver/delete', {
      category: 'rpc',
      type: 'rpc/driver/delete',
      driverIds,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {deleteDrivers}`,
      { tags: ['rpc', 'driver'], info: driverIds },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Deleting [${driverIds}] Failed`,
      error,
    })
  }
})
